module.exports = __webpack_public_path__ + "static/sebring_logo-4286aebb31e24c0926ec58d4644ccd21.svg";